/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IMfrmHeaderData } from './mfrm-header.data';
import { IMfrmHeaderProps } from './mfrm-header.props.autogenerated';

export interface IMfrmHeaderViewProps extends IMfrmHeaderProps<IMfrmHeaderData> { }

/**
 *
 * MfrmHeader component
 * @extends {React.PureComponent<IMfrmHeaderProps<IMfrmHeaderData>>}
 */
class MfrmHeader extends React.PureComponent<IMfrmHeaderProps<IMfrmHeaderData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MfrmHeader;
